import { useEffect, useState } from 'react';
import { Card } from '@/components/ui/Card';
import { Slider } from '@/components/ui/Slider';
import { Toggle } from '@/components/ui/Toggle';
import { usePlayer, useUpdatePlayerSettings } from '@/api/queries';
import { useAuthStore } from '@/store/authStore';
import { hapticNotify } from '@/lib/telegram';
import { useUIStore } from '@/store/uiStore';

export function GeneralTab() {
  const userId = useAuthStore((s) => s.userId);
  const { data } = usePlayer(userId);
  const player = data?.player;
  const update = useUpdatePlayerSettings(userId ?? 0);
  const pushNotification = useUIStore((s) => s.pushNotification);

  const [zeal, setZeal] = useState(50);
  const [adventureSpirit, setAdventureSpirit] = useState(1);
  const [adventureSpiritLocked, setAdventureSpiritLocked] = useState(false);
  const [hpThreshold, setHpThreshold] = useState(20);
  const [pvpEnabled, setPvpEnabled] = useState(false);

  useEffect(() => {
    if (!player) return;
    const locked = player.adventure_spirit_locked ?? false;
    setZeal(player.zeal ?? 50);
    setAdventureSpiritLocked(locked);
    // Auto mode follows the current grade; manual mode keeps the stored value.
    setAdventureSpirit(locked ? (player.adventure_spirit ?? 1) : player.current_grade);
    setHpThreshold(player.hp_threshold ?? 20);
    setPvpEnabled(player.pvp_enabled ?? false);
  }, [player?.user_id]); // eslint-disable-line react-hooks/exhaustive-deps

  const commit = async (patch: Record<string, unknown>) => {
    if (!userId) return;
    try {
      await update.mutateAsync(patch);
    } catch (err) {
      hapticNotify('error');
      const message = err instanceof Error ? err.message : 'Не удалось сохранить';
      pushNotification({ type: 'error', message });
    }
  };

  if (!player) {
    return <div className="text-white/40 text-sm">Загружаем…</div>;
  }

  return (
    <div className="space-y-3">
      <Card className="p-4 space-y-3">
        <h3 className="text-sm uppercase tracking-wide text-white/40 font-semibold">
          Рвение
        </h3>
        <p className="text-xs text-white/50 leading-snug">
          При каком уровне энергии персонаж направится к ближайшему городу
        </p>
        <Slider
          value={zeal}
          min={0}
          max={100}
          onChange={setZeal}
          onCommit={(v) => commit({ zeal: v })}
          suffix="%"
        />
      </Card>

      <Card className="p-4 space-y-3">
        <h3 className="text-sm uppercase tracking-wide text-white/40 font-semibold">
          Дух Приключений
        </h3>
        <p className="text-xs text-white/50 leading-snug">
          Максимальный грейд локаций для исследования. 🔓 Авто — следует за уровнем. 🔒
          Ручной — выбирай сам (даже опасные зоны!)
        </p>
        <Slider
          value={adventureSpirit}
          min={1}
          max={10}
          onChange={setAdventureSpirit}
          onCommit={(v) => commit({ adventure_spirit: v })}
          disabled={!adventureSpiritLocked}
        />
        <Toggle
          checked={adventureSpiritLocked}
          onChange={(v) => {
            setAdventureSpiritLocked(v);
            if (v) {
              // Lock -> manual mode, keep the currently shown grade.
              commit({ adventure_spirit_locked: true, adventure_spirit: adventureSpirit });
            } else {
              // Unlock -> auto mode, follow the current grade.
              setAdventureSpirit(player.current_grade);
              commit({ adventure_spirit_locked: false, adventure_spirit: player.current_grade });
            }
          }}
          label="Зафиксировать (ручной режим)"
        />
      </Card>

      <Card className="p-4 space-y-3">
        <h3 className="text-sm uppercase tracking-wide text-white/40 font-semibold">
          Порог здоровья
        </h3>
        <p className="text-xs text-white/50 leading-snug">
          Минимальный % HP, при котором вайфу будет выбрана для боя. Раненые вайфу (ниже
          порога) не участвуют в сражениях.
        </p>
        <Slider
          value={hpThreshold}
          min={0}
          max={100}
          onChange={setHpThreshold}
          onCommit={(v) => commit({ hp_threshold: v })}
          suffix="%"
        />
      </Card>

      <Card className="p-4 space-y-2">
        <div className="flex items-center justify-between gap-3">
          <h3 className="text-sm uppercase tracking-wide text-white/40 font-semibold">
            Stupid Military Долбоёб
          </h3>
          <Toggle
            checked={pvpEnabled}
            onChange={(v) => {
              setPvpEnabled(v);
              commit({ pvp_enabled: v });
            }}
          />
        </div>
        <p className="text-xs text-white/50 leading-snug">Пиздиться будешь? Да или да?</p>
      </Card>
    </div>
  );
}
